/* global PAYPAL */
import getPageNameFromUrl from './PageNameFromUrl'
import serverData from './server-data'

// prettier-ignore
export default function setupAnalytics() {
	(function setupFPTI(win) {
		if (!win.fpti) {
			win.fpti = {}
		}

		win.fpti = serverData && serverData.fpti
		const fptiName = getPageName(win) || win.fpti.name;
		const	fptiDataString = win.fpti['dataString']; // eslint-disable-line
		const	fptiServerURL = win.fpti['serverURL'] // eslint-disable-line

		win.PAYPAL = win.PAYPAL || {}
		if (typeof win.PAYPAL.analytics !== 'undefined') {
			win.PAYPAL.core = win.PAYPAL.core || {}
			win.PAYPAL.core[fptiName] = win.PAYPAL.analytics.setup({
				data: fptiDataString,
				url: fptiServerURL,
			})
		}

		function clickListener(err) {
			// TODO: Remove defaults after names are integrated across the app
			const listOfSupportedTags = {
					A: true,
					BUTTON: true,
					// For radio buttons
					LABEL: ((event) => {
						return event.target.getAttribute('for')
					}),
				};
			const isSupportedForTracking =
					listOfSupportedTags[err.target.tagName.toUpperCase()];
			const linkName = err.target.name || err.target.getAttribute('for') || ''
			const fptiDisabledIds = ["cookieStatementLink"];
			if (
				isSupportedForTracking &&
				(isSupportedForTracking === true || isSupportedForTracking(err))
				&& !(fptiDisabledIds.includes(err.target && err.target.getAttribute('id')))
			) {
				triggerFPTIClick(win, linkName)
			} else if (
				err.target.tagName.toUpperCase() === 'DIV' ||
				err.target.tagName.toUpperCase() === 'SPAN'
			) {
				triggerFPTIClick(win, getLinkName(err.target))
			}
		}

		win.addEventListener('click', clickListener, false)

		win.PAYPAL.fpti = {
			triggerFPTIClick,
			triggerFPTIImpression,
		}

		return win.PAYPAL.fpti
	})(window)
}

export function fptiCustomImpression(data, onceData = {}) {
  if (
    window &&
    window.PAYPAL &&
    window.PAYPAL.analytics &&
    window.PAYPAL.analytics.instance
  ) {
    setTimeout(function () {
      nativeAppData(data)
      window.PAYPAL.analytics.instance.recordImpression({ data }, onceData)
    }, 200)
  }
}

export function fptiCustomSetup(data, trackImpression = true) {
  if (
    window &&
    window.PAYPAL &&
    window.PAYPAL.analytics &&
    window.PAYPAL.analytics.instance
  ) {
    setTimeout(function () {
      nativeAppData(data)
      const updatedData = Object.assign({}, window.fpti, data)
      window.PAYPAL.analytics.setup({ data: updatedData, trackImpression })
    }, 200)
  }
}

export function getFptiPage(url) {
  url = url || window.location.pathname
  url = url.split(/[?#]/)[0]
  return getPageNameFromUrl(serverData.appUrl, url)
}

export function fptiCustomClick(data) {
  if (
    window &&
    window.PAYPAL &&
    window.PAYPAL.analytics &&
    window.PAYPAL.analytics.instance
  ) {
    setTimeout(function () {
      nativeAppData(data)
      window.PAYPAL.analytics.instance.recordClick({ data })
    }, 200)
  }
}

// Custom values sent to FPTI if experience comes from native app
function nativeAppData(fptiData) {
  if (fptiData) {
    if (serverData.nativeREF) {
      fptiData.ref_vid = serverData.nativeREF
    }
    if (serverData.nativeGUID) {
      fptiData.ref_guid = serverData.nativeGUID
    }
    if (serverData.nativeINTN) {
      fptiData.intn = serverData.nativeINTN
    }
  }
}

// Alternative to pointer-events in CSS.
// Drills up to 5 levels to check for 'A' or 'BUTTON' tags
function getLinkName(elementNode, currentDepthCount = 0) {
  const DEPTH_LIMIT = 5
  if (currentDepthCount > DEPTH_LIMIT || !elementNode) {
    return ''
  }
  if (
    elementNode.tagName.toUpperCase() === 'A' ||
    elementNode.tagName.toUpperCase() === 'BUTTON'
  ) {
    return elementNode.name || ''
  }
  currentDepthCount = currentDepthCount + 1
  return getLinkName(elementNode.parentElement, currentDepthCount)
}

function triggerFPTIImpression(win) {
  const pageGroup = `main:${win.fpti.comp}:${getPageName(win)}`
  const pageName = `main:${win.fpti.comp}:${getPageName(win)}:::`

  if (win.fpti.link) {
    win.fpti.rlink = win.fpti.link
  }
  if (win.fpti.pglk) {
    win.fpti.rpage = win.fpti.page
  }

  win.fpti.pgrp = pageGroup
  win.fpti.page = pageName
  win.fpti.link = null
  win.fpti.pglk = null
  win.fpti.pgln = null

  if (win.PAYPAL.instance) {
    win.PAYPAL.instance.recordImpression()
  }
}

function triggerFPTIClick(win, linkName) {
  if (!win.PAYPAL.instance) {
    setFPTIInstance(win)
  }

  win.fpti.link = linkName
  win.fpti.pglk = `${win.fpti.pgrp}|${linkName}`
  win.fpti.pgln = `${win.fpti.page}|${linkName}`

  if (win.PAYPAL.instance && linkName) {
    win.PAYPAL.instance.recordClick()
  }
}

function setFPTIInstance(win) {
  const fptiServerURL = win.fpti['serverURL'] // eslint-disable-line
  win.PAYPAL.instance = new PAYPAL.analytics.Analytics()
  win.PAYPAL.instance.options.request.url = fptiServerURL
}

function getPageName(win, url = win.location.pathname) {
  url = getPathFromUrl(url)
  return getPageNameFromUrl(serverData.appUrl, url)
}

// Remove query string for FPTI pagenames
function getPathFromUrl(url) {
  return url.split(/[?#]/)[0]
}
